import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMarketPlaceStores } from "../../../../../hooks/api/queries/useMarketPlace";
import { useConnectChowdeckStore } from "../../../../../hooks/api/mutations/useChowdeck";
import { ToastContext } from "../../../../../hooks/context";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { cleanObject } from "../../../../../helpers";
import { pathConstants } from "../../../../../routes/pathContants";

export const useChowdeckStoreConnect = ({ providerKey }) => {
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { connection_id } = useParams();
  const { search } = useUrlSearch();

  const { data: chowdeckStores, isLoading } = useGetMarketPlaceStores({
    queryParams: { connection_id },
    isEnabled: connection_id || providerKey === "squareup" ? true : false,
    providerKey,
  });

  const [formData, setFormData] = useState({
    lumi_store_id: "",
    marketplace_store_ref: "",
    marketplace_store_name: "",
    price_recording_option: "PROVIDER_TOTAL",
  });

  const { mutate: connectStore, isLoading: isConnecting } =
    useConnectChowdeckStore({
      queryParams: cleanObject({ connection_id }),
      providerKey,
    });

  const handleStoreConnection = () => {
    connectStore(
      cleanObject({
        ...formData,
        marketplace_store_currency: chowdeckStores?.find(
          (item) =>
            `${item?.reference}` === `${formData?.marketplace_store_ref}`,
        )?.currency_code,
      }),
      {
        onSuccess: (res) => {
          triggerToast("Store connection succesful", "success");

          const storeMappingData = res?.data?.data;
          const queries = `?mapping_id=${storeMappingData?.id}&lumi_store_id=${formData?.lumi_store_id}`;

          if (providerKey === "squareup")
            return navigate(
              pathConstants.APPS_SQUAREUP_CONNECT_STORE_EDIT({
                connection_id: storeMappingData?.marketplace_conn?.id,
              }) + queries,
            );

          if (providerKey === "chowdeck")
            return navigate(
              pathConstants.APPS_CHOWDECK_CONNECT_STORE_EDIT({
                connection_id: storeMappingData?.marketplace_conn?.id,
              }) + queries,
            );
        },
      },
    );
  };

  // useEffect(() => {
  //   if (storeMappingData) {
  //     filterByKey("mapping_id", storeMappingData?.id);
  //     filterByKey("lumi_store_id", formData?.lumi_store_id);
  //   }
  // }, [storeMappingData]);

  return {
    isConnecting,
    storeList,
    formData,
    chowdeckStores,
    isLoading,
    mapping_id: search.get("mapping_id"),
    setFormData,
    handleStoreConnection,
  };
};
